export const getCategoryClass = (category) => {
    if (!category) return "";
    let normalizedCategory = category
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/\//g, "-")
        .replace(/[^a-z0-9-]/g, "");
    if (normalizedCategory.includes("clinical-medicine"))
        return "clinical-medicine";
    if (normalizedCategory.includes("medical-education"))
        return "medical-education";
    if (normalizedCategory.includes("medical-communication"))
        return "medical-communication";
    if (normalizedCategory.includes("project-management"))
        return "project-management";
    if (
        normalizedCategory.includes("pharmaceuticals") ||
        normalizedCategory.includes("pharmaceutical")
    )
        return "pharmaceuticals";
    if (
        normalizedCategory.includes("clinical-research") ||
        normalizedCategory.includes("clinical-reserach")
    )
        return "clinical-research";
    if (
        normalizedCategory.includes("healthtech") ||
        normalizedCategory.includes("health-tech")
    )
        return "health-tech";
    if (
        normalizedCategory.includes("hospital") ||
        normalizedCategory.includes("clinic-management")
    )
        return "hospital-clinic-management";
    if (
        normalizedCategory.includes("consulting") ||
        normalizedCategory === "management"
    )
        return "management-consulting";
    if (normalizedCategory.includes("entrepreneurship"))
        return "entrepreneurship";
    if (
        normalizedCategory.includes("policy") ||
        normalizedCategory.includes("legal") ||
        normalizedCategory.includes("ethics")
    )
        return "policy";
    if (
        normalizedCategory.includes("marketing") ||
        normalizedCategory.includes("sales")
    )
        return "marketing";
    if (normalizedCategory.includes("creative")) return "creative";
    if (
        normalizedCategory.includes("wellness") ||
        normalizedCategory.includes("lifestyle")
    )
        return "wellness";
    if (normalizedCategory.includes("insurance")) return "insurance";
    return normalizedCategory.split("-")[0];
};
